<script>
  import { onMount } from "svelte";
  import {External, M} from "../../../external";

  export let data;
  export let valid;
  export let onChange;

  if (!data) data = {};
  if (!data.settings) data.settings = data.settings || [];

  const onTagsSelected = (tags) => {
    data.settings = tags;
    data.name = data.settings.map((setting) => setting.value).join(", ");
    valid = data.settings && data.settings.length > 0;
    onChange();
  };

  const click = () => {
    let selectedTags = data.settings.map((setting) => External.getById(External.Website.crmTags, setting.key, false)).filter((tag) => !!tag);

    External.UITools.selectTags(selectedTags, (newTags) => {
      let selected = newTags.map((tag) => {
        return { key: tag.id + "", value: tag.label + "" };
      });
      onTagsSelected(selected);
    });
  };

  onMount(() => {
    valid = data.settings.length > 0;
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.TRIGGER_TAG_ADD}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <ul class="groups category-groups mb-15">
      <li>
        <a on:click={click} rel="action" data-action="editProductCategories" class="middle-button gray">{M.SELECT_TAGS}</a>
      </li>
      <li data-role="count">{data.settings.length} {data.settings.length === 1 ? M.TAG : M.TAGS} {M.SELECTED}</li>
    </ul>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
